import React from 'react';
import { Typography, Grid } from 'antd';
import { STEP_CONFIG } from '../constants';
import { THEME_COLORS, COLORS } from '../../../utils/colors';
import hooptieLogo from '../../../assets/images/HooptieNewLogo.png';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const StepIndicator = ({ currentStep, steps = STEP_CONFIG, isMobileView = false }) => {
  const screens = useBreakpoint();
  const isMobile = isMobileView || !screens.md;
  const currentIndex = steps.findIndex(step => step.key === currentStep);
  
  if (isMobile) {
    // Horizontal layout for mobile
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        gap: '8px',
        overflowX: 'auto',
        paddingBottom: '8px',
        WebkitOverflowScrolling: 'touch'
      }}>
      {steps.map((step, index) => {
        const isCompleted = index < currentIndex;
        const isCurrent = index === currentIndex;
        const isPending = index > currentIndex;
        
        return (
          <div key={step.key} style={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center',
            gap: '6px',
            minWidth: '60px',
            flexShrink: 0
          }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              background: isCompleted || isCurrent ? COLORS.PRIMARY[500] : THEME_COLORS.DARK.bg.tertiary,
              color: isCompleted || isCurrent ? '#ffffff' : THEME_COLORS.DARK.text.muted,
              border: isCompleted || isCurrent ? 'none' : `1px solid ${THEME_COLORS.DARK.border.primary}`,
              flexShrink: 0
            }}>
              {index + 1}
            </div>
            <Text style={{ 
              color: isCompleted || isCurrent ? THEME_COLORS.DARK.text.primary : THEME_COLORS.DARK.text.muted,
              fontSize: '10px',
              fontWeight: isCurrent ? 600 : 400,
              textAlign: 'center',
              lineHeight: '1.2'
            }}>
              {step.title.split(' ')[0]}
            </Text>
          </div>
        );
      })}
      </div>
    );
  }
  
  // Vertical layout for desktop - active step: vertical bar + glow; inactive: dimmer
  return (
    <div style={{ color: THEME_COLORS.DARK.text.primary }}>
      <div style={{
        marginBottom: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img
          src={hooptieLogo}
          alt="Hooptie Logo"
          style={{
            height: '180px',
            width: 'auto',
            filter: 'brightness(0) invert(1)',
          }}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {steps.map((step, index) => {
          const isCompleted = index < currentIndex;
          const isCurrent = index === currentIndex;
          return (
            <div
              key={step.key}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                padding: '12px 10px 12px 0',
                borderRadius: '8px',
                position: 'relative',
                background: isCurrent ? 'rgba(59, 130, 246, 0.08)' : 'transparent',
                boxShadow: isCurrent ? '0 0 24px rgba(59, 130, 246, 0.12)' : 'none',
                borderRight: isCurrent ? '3px solid #3b82f6' : '3px solid transparent',
              }}
            >
              <div style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                flexShrink: 0,
                background: isCompleted || isCurrent ? COLORS.PRIMARY[500] : 'rgba(255,255,255,0.12)',
                color: isCompleted || isCurrent ? '#ffffff' : 'rgba(255,255,255,0.5)',
                border: 'none',
              }}>
                {index + 1}
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <Text style={{
                  color: isCurrent ? '#fff' : isCompleted ? 'rgba(255,255,255,0.85)' : 'rgba(255,255,255,0.45)',
                  fontSize: '14px',
                  fontWeight: isCurrent ? 600 : 400,
                  display: 'block',
                  marginBottom: '2px',
                }}>
                  {step.title}
                </Text>
                <Text style={{
                  color: isCurrent ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.35)',
                  fontSize: '11px',
                  display: 'block',
                  lineHeight: 1.3,
                }}>
                  {step.description}
                </Text>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepIndicator;
